module.exports = __webpack_public_path__ + "img/ch70.4423a03d.jpg";